import { render, staticRenderFns } from "./DevicesList.vue?vue&type=template&id=5459dd88&"
import script from "./DevicesList.vue?vue&type=script&lang=js&"
export * from "./DevicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5459dd88')) {
      api.createRecord('5459dd88', component.options)
    } else {
      api.reload('5459dd88', component.options)
    }
    module.hot.accept("./DevicesList.vue?vue&type=template&id=5459dd88&", function () {
      api.rerender('5459dd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/devicesoverview/deviceslist/DevicesList.vue"
export default component.exports